module.exports = __webpack_public_path__ + "img/LogoRedesign_DrThumm_RZ_rgb_Invert.fc7d1565.svg";